var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 89.91 32.428"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Group 354"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.677 9.804a1.72 1.72 0 0 0-1.718 1.718v11.525a1.718 1.718 0 1 0 3.436 0V11.522a1.72 1.72 0 0 0-1.718-1.718",
  "data-name": "Path 230"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.677 9.804h-2.414a4.806 4.806 0 0 0-4.8 4.8v8.442a1.718 1.718 0 1 0 3.436 0v-8.442a1.366 1.366 0 0 1 1.365-1.365h2.414a1.718 1.718 0 1 0 0-3.436",
  "data-name": "Path 231"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.107.141a1.72 1.72 0 0 0-1.718 1.718v21.187a1.718 1.718 0 1 0 3.436 0V1.859A1.72 1.72 0 0 0 71.107.141",
  "data-name": "Path 232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.106 9.804h-3.918a4.79 4.79 0 0 0-4.785 4.785v8.458a1.718 1.718 0 1 0 3.436 0v-8.458a1.35 1.35 0 0 1 1.349-1.349h3.918a1.35 1.35 0 0 1 1.349 1.349v8.458a1.718 1.718 0 1 0 3.436 0v-8.458a4.79 4.79 0 0 0-4.785-4.785",
  "data-name": "Path 233"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.613 10.05h-5.27a4.85 4.85 0 0 0-4.848 4.847v5.27a4.85 4.85 0 0 0 4.845 4.845h2.755a1.718 1.718 0 1 0 0-3.436H45.34a1.41 1.41 0 0 1-1.409-1.409v-5.27a1.41 1.41 0 0 1 1.409-1.409h5.27a1.41 1.41 0 0 1 1.41 1.409v8.151a1.718 1.718 0 0 0 3.436 0v-8.151a4.85 4.85 0 0 0-4.846-4.845",
  "data-name": "Path 234"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.228 23.047a1.72 1.72 0 0 0-1.718-1.718h-1.9a1.35 1.35 0 0 1-1.349-1.349v-8.458a1.718 1.718 0 0 0-3.436 0v8.457a4.79 4.79 0 0 0 4.785 4.785h1.9a1.72 1.72 0 0 0 1.718-1.718",
  "data-name": "Path 235"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.192 9.804a1.72 1.72 0 0 0-1.718 1.718v15.6a1.87 1.87 0 0 1-1.868 1.867h-1.2a1.718 1.718 0 1 0 0 3.436h1.2a5.31 5.31 0 0 0 5.3-5.3v-15.6a1.72 1.72 0 0 0-1.718-1.718",
  "data-name": "Path 236"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.846 24.985h5.27a4.85 4.85 0 0 0 4.844-4.845v-5.27a4.85 4.85 0 0 0-4.845-4.845H7.348a1.718 1.718 0 0 0 0 3.436h2.767a1.41 1.41 0 0 1 1.409 1.409v5.27a1.41 1.41 0 0 1-1.409 1.409H4.846a1.41 1.41 0 0 1-1.41-1.409V1.718a1.718 1.718 0 1 0-3.436 0V20.14a4.85 4.85 0 0 0 4.846 4.845",
  "data-name": "Path 237"
}))));
export default SvgLogo;